import InsideSales from './InsideSales';

export default InsideSales;
